import _regeneratorRuntime from "C:\\Source\\SysDem\\04. SysDem.Go\\SysDem.Go.APIandWeb\\src\\frontend\\DemOffice-UI-develop\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _asyncToGenerator from "C:\\Source\\SysDem\\04. SysDem.Go\\SysDem.Go.APIandWeb\\src\\frontend\\DemOffice-UI-develop\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "C:\\Source\\SysDem\\04. SysDem.Go\\SysDem.Go.APIandWeb\\src\\frontend\\DemOffice-UI-develop\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Source\\SysDem\\04. SysDem.Go\\SysDem.Go.APIandWeb\\src\\frontend\\DemOffice-UI-develop\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\Source\\SysDem\\04. SysDem.Go\\SysDem.Go.APIandWeb\\src\\frontend\\DemOffice-UI-develop\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\Source\\SysDem\\04. SysDem.Go\\SysDem.Go.APIandWeb\\src\\frontend\\DemOffice-UI-develop\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\Source\\SysDem\\04. SysDem.Go\\SysDem.Go.APIandWeb\\src\\frontend\\DemOffice-UI-develop\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
import { HeaderNames } from "./HeaderNames";
import { HttpClient } from "./HttpClient";
/** @private */

export var AccessTokenHttpClient =
/*#__PURE__*/
function (_HttpClient) {
  _inherits(AccessTokenHttpClient, _HttpClient);

  function AccessTokenHttpClient(innerClient, accessTokenFactory) {
    var _this;

    _classCallCheck(this, AccessTokenHttpClient);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AccessTokenHttpClient).call(this));
    _this._innerClient = innerClient;
    _this._accessTokenFactory = accessTokenFactory;
    return _this;
  }

  _createClass(AccessTokenHttpClient, [{
    key: "send",
    value: function () {
      var _send = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(request) {
        var allowRetry, response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                allowRetry = true;

                if (!(this._accessTokenFactory && (!this._accessToken || request.url && request.url.indexOf("/negotiate?") > 0))) {
                  _context.next = 6;
                  break;
                }

                // don't retry if the request is a negotiate or if we just got a potentially new token from the access token factory
                allowRetry = false;
                _context.next = 5;
                return this._accessTokenFactory();

              case 5:
                this._accessToken = _context.sent;

              case 6:
                this._setAuthorizationHeader(request);

                _context.next = 9;
                return this._innerClient.send(request);

              case 9:
                response = _context.sent;

                if (!(allowRetry && response.statusCode === 401 && this._accessTokenFactory)) {
                  _context.next = 18;
                  break;
                }

                _context.next = 13;
                return this._accessTokenFactory();

              case 13:
                this._accessToken = _context.sent;

                this._setAuthorizationHeader(request);

                _context.next = 17;
                return this._innerClient.send(request);

              case 17:
                return _context.abrupt("return", _context.sent);

              case 18:
                return _context.abrupt("return", response);

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function send(_x) {
        return _send.apply(this, arguments);
      }

      return send;
    }()
  }, {
    key: "_setAuthorizationHeader",
    value: function _setAuthorizationHeader(request) {
      if (!request.headers) {
        request.headers = {};
      }

      if (this._accessToken) {
        request.headers[HeaderNames.Authorization] = "Bearer ".concat(this._accessToken);
      } // don't remove the header if there isn't an access token factory, the user manually added the header in this case
      else if (this._accessTokenFactory) {
          if (request.headers[HeaderNames.Authorization]) {
            delete request.headers[HeaderNames.Authorization];
          }
        }
    }
  }, {
    key: "getCookieString",
    value: function getCookieString(url) {
      return this._innerClient.getCookieString(url);
    }
  }]);

  return AccessTokenHttpClient;
}(HttpClient);